"use client";

import { createContext, useContext } from "react";

import type { BrandId } from "./tokens";

/**
 * The brand the SERVER resolved for this request (#411), provided by
 * ExperienceProvider from its initial payload. Lets brand-branching client
 * components (useCurrentBrand -> login chrome, BrandLogo) render the right
 * brand on their FIRST render — server and hydration alike — instead of
 * starting on DEFAULT_BRAND and correcting after an effect. Null = nothing
 * served yet (the pre-#411 state, or a server-side bootstrap failure): the
 * consumer falls back to the <html data-brand> attribute as before.
 */
export const ServedBrandContext = createContext<BrandId | null>(null);

export function useServedBrand(): BrandId | null {
  return useContext(ServedBrandContext);
}
